import { render, staticRenderFns } from "./UserNews.vue?vue&type=template&id=ef890f9c&"
import script from "./UserNews.vue?vue&type=script&lang=js&"
export * from "./UserNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports